const createGoogleCoordinates = (lat, lng) => ({
  lat: Number(lat),
  lng: Number(lng),
})

export default createGoogleCoordinates
